import { createCRUDHook } from './createCRUDHook';
import {
  IntermediateProductionDto,
  IntermediateProductionFilteredEntitiesDto,
  FilterOptionModel,
} from 'utils/models';
import {
  FILTERED_ENTITIES,
  TBL_INTERMEDIATE_PART_PRODUCTION,
} from './apiEndPoints';
import { prepareQueryParams } from 'utils';

interface IntermediateProductionCustomOperations {
  fetchIntermediateProductionDataByFE: (
    filteredEntities: FilterOptionModel
  ) => Promise<IntermediateProductionFilteredEntitiesDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  IntermediateProductionDto,
  IntermediateProductionDto[],
  IntermediateProductionCustomOperations
>({
  entityName: 'IntermediateProduction',
  endpoint: TBL_INTERMEDIATE_PART_PRODUCTION,

  customOperations: (auth) => ({
    fetchIntermediateProductionDataByFE: async (
      filteredEntities: FilterOptionModel
    ): Promise<IntermediateProductionFilteredEntitiesDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_INTERMEDIATE_PART_PRODUCTION +
            FILTERED_ENTITIES +
            `?${prepareQueryParams(filteredEntities)}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const IntermediateProductionContext = Context;
export const useIntermediateProductionManager = useManager;
export const useIntermediateProduction = useConsumer;
